module.exports = __webpack_public_path__ + "img/icon_map_108_off_101.63cef9ef.png";